'use client';
import React, { useState } from 'react';
import ServiceItem from './service-item';
import { Button, Div, Media } from '@pezeshk-book/ui-kit';
import { useDispatch } from 'react-redux';
import { UsersActions } from '@store/users/users-action';
import routes from '@routes';
import { AlertActions } from '@store/alert/alert-action';
import dynamic from 'next/dynamic';
import PlayIcon from '@icons-components/play-icon';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import { LocaleTypes } from '@dictionaries-types';

const ServiceTutorial = dynamic(() => import('./service-tutorial'));

const GRID_COLS: any = {
  '1': 'lg:grid-cols-1',
  '2': 'lg:grid-cols-2',
  '3': 'lg:grid-cols-3',
  '4': 'lg:grid-cols-4',
  '5': 'lg:grid-cols-5',
  '6': 'lg:grid-cols-6',
};

const Services = ({ translate }: {translate: any}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState('');
  const { lang } = useParams<{ lang: LocaleTypes }>();

  let servicesCount = 0;
  if (process.env.PHARMACY_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }
  if (process.env.CONSULT_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }
  if (process.env.LABORATORY_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }
  if (process.env.HOME_CARE_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }
  if (process.env.APPOINTMENT_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }
  if (process.env.PRODUCT_SERVICE_ACTIVE === 'true') {
    servicesCount++;
  }

  const showTutorialHandler = (source: string) => {
    setOpen(true);
    setSource(source);
  };

  const videoOnProgress = () => {
    dispatch(AlertActions.showAlert({ text: translate.messages.video_on_progress, severity: 'warning' }));
  };

  return (
    <Div className={'flex-col w-full'}>
      <Div className={`grid ${GRID_COLS[servicesCount]} grid-cols-1 sm:grid-cols-2 sm:gap-6 gap-3 md:mt-9 sm:mt-5 mt-6`}>
        <ServiceItem
          isActive={process.env.PHARMACY_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          item={{
            icon: '/images/home-screen/services/pharmacies-temp.png',
            title: translate.online_pharmacy.title,
            subtitle: translate.online_pharmacy.description,
            link: getParseRoute({ pathname: routes['route.pharmacies.index'], locale: lang }),
            id: '3',
            hasInsurance: false,
            // isNew: true,
            onTutorialClick: () => {
              showTutorialHandler('/video/pharmacies-tutorial-desktop.mp4');
            },
          }}/>
        <ServiceItem
          isActive={process.env.PRODUCT_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          hasTutorial={false}
          item={{
            icon: '/images/home-screen/services/product-temp.png',
            title: translate.products.title,
            subtitle: translate.products.description,
            link: getParseRoute({ pathname: routes['route.products.index'], locale: lang }),
            hasInsurance: false,
            onClick: () => {},
            onTutorialClick: () => videoOnProgress,
          }}/>
        <ServiceItem
          isActive={process.env.LABORATORY_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          comingSoon={true}
          item={{
            icon: '/images/home-screen/services/lab-temp.png',
            title: translate.laboratory.title,
            subtitle: translate.laboratory.description,
            link: getParseRoute({ pathname: routes['route.labs.index'], locale: lang }),
            id: '1',
            hasInsurance: true,
            onTutorialClick: () => {
              showTutorialHandler('/video/lab-tutorial-desktop.m4v');
            },
          }}/>
        <ServiceItem
          isActive={process.env.CONSULT_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          item={{
            icon: '/images/home-screen/services/consult-temp.png',
            title: translate.consult.title,
            subtitle: translate.consult.description,
            link: getParseRoute({ pathname: routes['route.users.index'], locale: lang }),
            onClick: () => {
              dispatch(UsersActions.setFilterItems({
                key: 'serviceType',
                value: 'مشاوره',
                id: '2',
              }));
            },
            id: '2',
            onTutorialClick: () => {
              showTutorialHandler('/video/consult-tutorial-desktop.mp4');
            },
          }}/>
        <ServiceItem
          isActive={process.env.HOME_CARE_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          item={{
            icon: '/images/home-screen/services/services-temp.png',
            title: translate.medical_services.title,
            subtitle: translate.medical_services.description,
            link: getParseRoute({ pathname: routes['route.home-care.index'], locale: lang }),
            id: '5',
            onTutorialClick: () => {
              showTutorialHandler('/video/home-care-tutorial-desktop.mp4');
            },
          }}/>
        <ServiceItem
          isActive={process.env.APPOINTMENT_SERVICE_ACTIVE === 'true'}
          buttonsTitle={translate.buttons}
          chipsTitle={translate.chips}
          isUpdating={true}
          item={{
            icon: '/images/home-screen/services/appointment-temp.png',
            title: translate.appointment.title,
            subtitle: translate.appointment.description,
            link: getParseRoute({ pathname: routes['route.users.index'], locale: lang }),
            onClick: () => {
              // dispatch(UsersActions.setFilterItems({
              //   key: 'serviceType',
              //   value: 'نوبت حضوری',
              //   id: '1',
              // }));
            },
            id: '4',
            onTutorialClick: videoOnProgress,
          }}/>
      </Div>
      <Media at={'xs'}>
        <Div className={'flex-col w-full px-2'}>
          {process.env.PHARMACY_SERVICE_ACTIVE === 'true' ? (
            <Button startAdornment={<PlayIcon/>} variant={'text'} onClick={() => showTutorialHandler('/video/pharmacies-tutorial-mobile.mp4')} color={'control'} className={'w-full bg-white !justify-start my-1'}>
              {translate.online_pharmacy.tutorial_button}
            </Button>
          ) : null}
          {process.env.LABORATORY_SERVICE_ACTIVE === 'true' ? (
            <Button startAdornment={<PlayIcon/>} variant={'text'} onClick={() => showTutorialHandler('/video/lab-tutorial-mobile.m4v')} color={'control'} className={'w-full bg-white !justify-start my-1'}>
              {translate.laboratory.tutorial_button}
            </Button>
          ) : null}
          {process.env.CONSULT_SERVICE_ACTIVE === 'true' ? (
            <Button startAdornment={<PlayIcon/>} variant={'text'} onClick={() => showTutorialHandler('/video/consult-tutorial-mobile.mp4')} color={'control'} className={'w-full bg-white !justify-start my-1'}>
              {translate.consult.tutorial_button}
            </Button>
          ) : null}
          {process.env.HOME_CARE_SERVICE_ACTIVE === 'true' ? (
            <Button startAdornment={<PlayIcon/>} variant={'text'} onClick={() => showTutorialHandler('/video/home-care-tutorial-mobile.mp4')} color={'control'} className={'w-full bg-white !justify-start my-1'}>
              {translate.medical_services.tutorial_button}
            </Button>
          ) : null}
          {process.env.APPOINTMENT_SERVICE_ACTIVE === 'true' ? (
            <Button startAdornment={<PlayIcon/>} disabled={true} variant={'text'} onClick={videoOnProgress} color={'control'} className={'w-full bg-white !justify-start my-1'}>
              {translate.appointment.tutorial_button}
            </Button>
          ) : null}
        </Div>
      </Media>
      <ServiceTutorial buttonTitle={translate.buttons.close} source={source} openModal={open} onClose={() => setOpen(false)}/>
    </Div>
  );
};

export default Services;
